import Wrapper from '../../../core/wrapper';

export default {
  components: {
    Wrapper,
  },
  props: {
    title: {
      type: String,
      default: null,
    },
    hasBackButton: {
      type: Boolean,
      default: false,
    },
    onBack: {
      type: Function,
    },
  },
};
